'use client'

import { cn } from '@/website/utils/tailwindUtils';
import { useEffect, useRef, useState } from 'react';

export const Advert = ({
	id,
	className,
	...props
} : React.ComponentProps<"div">) => {
	const [advertLoaded, setAdvertLoaded] = useState(false);
	const advertRef = useRef<HTMLDivElement>(null!);
	useEffect(() => {
		if(!advertRef.current) return

		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if(mutation.type === 'childList') {
					if(mutation.addedNodes.length > 0) {
						setAdvertLoaded(true)
					}
				}
			})
		})

		observer.observe(advertRef.current, {
			childList: true,
			subtree: false
		})

		return () => observer.disconnect()
	}, [])

	return (

		<div ref={advertRef} id={id} className={cn(className, !advertLoaded && 'relative bg-(--page-background)')} {...props}>
			{!advertLoaded && (
				<div className={cn('absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex space-x-2')}>
					<span className={cn('w-4 h-4 bg-(--button-primary-background) rounded-full animate-bounce-dot')} style={{ animationDelay: '0s' }} />
					<span className={cn('w-4 h-4 bg-(--button-primary-background) rounded-full animate-bounce-dot')} style={{ animationDelay: '0.2s' }} />
					<span className={cn('w-4 h-4 bg-(--button-primary-background) rounded-full animate-bounce-dot')} style={{ animationDelay: '0.4s' }} />
				</div>
			)}
		</div>
	)
}
